import { Loader2, CreditCard, TrendingUp } from 'lucide-react';
import { format } from 'date-fns';
import { 
  Tooltip, 
  TooltipContent, 
  TooltipProvider, 
  TooltipTrigger 
} from '@/components/ui/tooltip';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useCredits } from '@/contexts/CreditContext';
import { useNavigate } from 'react-router-dom';

export function CreditsDisplay() {
  const { creditInfo, isLoading } = useCredits();
  const navigate = useNavigate();
  
  if (isLoading) {
    return (
      <div className="flex items-center gap-1 px-3 py-1.5 text-sm">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>Loading...</span>
      </div>
    );
  }
  
  // If there's no credit info, don't show anything
  if (!creditInfo) return null;
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="outline" 
            className="px-3 py-1.5 bg-background hover:bg-accent cursor-pointer transition-colors"
          >
            <CreditCard className="h-3.5 w-3.5 mr-1.5 text-primary" />
            <span className="font-medium">{creditInfo.available_credits}</span>
            <span className="ml-1 text-muted-foreground">credits</span>
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="bottom" sideOffset={5} className="p-0 overflow-hidden w-64">
          <div className="p-4 space-y-2">
            <div className="space-y-1">
              <p className="font-semibold text-sm flex items-center">
                <CreditCard className="h-3.5 w-3.5 mr-1.5 text-primary" />
                Credits
              </p>
              <div className="flex items-center justify-between">
                <p className="text-lg font-bold">{creditInfo.available_credits}</p>
                <Badge variant="outline" className="text-xs capitalize">
                  {creditInfo.tier} Plan
                </Badge>
              </div>
            </div>
            
            {creditInfo.next_refresh && (
              <p className="text-xs text-muted-foreground">
                Refreshes on {format(new Date(creditInfo.next_refresh), 'MMMM d, yyyy')}
              </p>
            )}
          </div>
          
          <div className="border-t p-2 bg-muted/20">
            <Button 
              size="sm" 
              variant="default" 
              className="w-full text-xs"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigate('/pricing');
              }}
            >
              <TrendingUp className="h-3.5 w-3.5 mr-1.5" />
              Upgrade Plan
            </Button>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
} 